import { useMemo } from 'react';
import { useAppSelector } from '@store/hooks';
import { selectUser } from '@store/slices';
import type { Persona, UsePersonaResult } from '@/types/auth.types';

export function usePersona(): UsePersonaResult {
  const user = useAppSelector(selectUser);

  return useMemo(() => {
    const persona: Persona = user?.persona ?? 'Employee';

    const isAdmin = persona === 'Admin';
    const isPlanner = persona === 'Planner';
    const isEmployee = persona === 'Employee';

    const hasPersona = (personas: Persona | Persona[]): boolean => {
      const personaList = Array.isArray(personas) ? personas : [personas];
      return personaList.includes(persona);
    };

    return {
      persona,
      isAdmin,
      isPlanner,
      isEmployee,
      hasPersona,
    };
  }, [user?.persona]);
}
